export class MongoSelectorUtils {
    static transformSimpleEqualToMongoEqual(selector) {
        const selectorMiniMongo = {};
        Object.keys(selector).forEach((key) => {
            const value = selector[key];
            selectorMiniMongo[key] =
                value !== null && typeof value === "object"
                    ? value
                    : { $eq: value };
        });
        return selectorMiniMongo;
    }

    /**
     * Minimongo local (webpack-parallel) não implementa $eq; igualdade é valor literal no campo.
     */
    static normalizeForLocalCollection(selector) {
        if (selector == null) return selector;
        if (typeof selector === "string") return { _id: selector };
        if (typeof selector !== "object") return selector;
        if (Array.isArray(selector)) {
            return selector.map((item) =>
                MongoSelectorUtils.normalizeForLocalCollection(item)
            );
        }
        const normalized = {};
        Object.keys(selector).forEach((key) => {
            const value = selector[key];
            if (key.startsWith("$")) {
                if (key === "$and" || key === "$or" || key === "$nor") {
                    normalized[key] = value.map((item) =>
                        MongoSelectorUtils.normalizeForLocalCollection(item)
                    );
                } else {
                    normalized[key] = value;
                }
                return;
            }
            normalized[key] =
                MongoSelectorUtils.normalizeFieldSelector(value);
        });
        return normalized;
    }

    static normalizeFieldSelector(value) {
        if (
            value === null ||
            typeof value !== "object" ||
            Array.isArray(value)
        ) {
            return value;
        }
        const keys = Object.keys(value);
        if (keys.length === 1 && keys[0] === "$eq") {
            return value.$eq;
        }
        if (keys.some((k) => k.startsWith("$"))) {
            return value;
        }
        return MongoSelectorUtils.normalizeForLocalCollection(value);
    }
}
